import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-copyright">shiskerstone © 2026</div>
      <div>
        <p>print@shiskerstone.xyz</p>
      </div>
      <nav className="footer-nav">
        <Link to="/about" onClick={toTop}>
          About
        </Link>

        <Link to="/contact" onClick={toTop}>
          Contact
        </Link>
        <Link to="/returns" onClick={toTop}>
          Returns
        </Link>
        <Link to="/shipping" onClick={toTop}>
          Shipping
        </Link>
        <Link to="/privacy" onClick={toTop}>
          Privacy
        </Link>
        <Link to="/cookies" onClick={toTop}>
          Cookies
        </Link>
        <Link to="/faqs" onClick={toTop}>
          FAQs
        </Link>
        <Link to="/terms" onClick={toTop}>
          Terms
        </Link>
      </nav>
    </footer>
  );
}

export default Footer;
